import * as compass from './ui/compass.js';
import * as coordinates from './ui/coordinates.js';
import * as compassModeIndicator from './ui/compass-mode-indicator.js';
import * as mapIndicator from './ui/map-indicator.js';

export {
    init,
    update,
    draw,
}

function init() {
    compass.init();
    compassModeIndicator.init();
    mapIndicator.init();
}

function update() {
    compass.update();
}

function draw() {
    compass.draw();
    coordinates.draw();
    compassModeIndicator.draw()
    mapIndicator.draw();
}